import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import AreaCard from "../AreaCard";
import Sidebar from "../../../sidebar";
import Projects from "../../../projects";
import Users from "../../../users";
import Profile from "../../../profile";
import KanbanBoard from "../../../kanban_board";
import Settings from "../../../settings";
import Dashboard from "../../../dashboard";
import ContasWilder from "../../../projects_t_engineering/ContasWilder/ContasWilder";
import InternRegisterUser from "../../../inter_register_user";
import UserIntern from "../../../../pages/user_intern";
import { setAreas } from "../../../../store/modules/area/actions";
import { guardianAreaService } from "../../../../services/guardianAreaService";
import {
  MainContainer,
  BackgroundPattern,
  SideContainer,
  ContentWrapper,
  HeaderSection,
  Title,
  Subtitle,
  ButtonGrid,
  SmallActionButton,
  ButtonIcon,
  ButtonText,
  AreaListWrapper,
} from "../styles";

const ArchivedAreas = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const collapsed = useSelector((state) => state.sidebar);
  const app_status = useSelector((state) => state.app_status.status);
  const location = useLocation();
  const user = location?.state?.user;

  const [archivedAreas, setArchivedAreas] = useState([]);

  // 🔹 1️⃣ Carrega áreas arquivadas na montagem do componente
 useEffect(() => {
  const fetchArchivedAreas = async () => {
    try {
      const data = await guardianAreaService.getArchivedGuardianAreas(); // 👈 chamada simplificada
      setArchivedAreas(data);
      dispatch(setAreas(data));
      console.log("Áreas arquivadas:", data);
    } catch (error) {
      console.error("❌ Erro ao buscar áreas arquivadas:", error);
    }
  };

  fetchArchivedAreas();
}, [dispatch]);

  return (
    <MainContainer collapsed={collapsed}>
      <BackgroundPattern />
      <Sidebar />
      <SideContainer>
        {app_status === "Projetos" ? (
          <Projects />
        ) : app_status === "Usuários" ? (
          <Users />
        ) : app_status === "Meu Perfil" ? (
          <Profile />
        ) : app_status === "Desenvolvimento" ? (
          <KanbanBoard />
        ) : app_status === "Configurações" ? (
          <Settings />
        ) : app_status === "cad_new_user" ? (
          <InternRegisterUser userType={location.state?.userType}/>
        ) : app_status === "edit_user" ? (
          <UserIntern user={user} />
        ) : app_status === "Dashboard" ? (
          <Dashboard />
        ) : app_status === "Contas" ? (
          <ContasWilder />
        ) : (
          <ContentWrapper>
            <ButtonGrid>
              <SmallActionButton onClick={() => navigate("/areas")}>
                <ButtonIcon>📋</ButtonIcon>
                <ButtonText>Voltar para Áreas Ativas</ButtonText>
              </SmallActionButton>
            </ButtonGrid>

            <HeaderSection>
              <Title>Áreas Arquivadas</Title>
              <Subtitle>Visualize as áreas de interesse arquivadas</Subtitle>
            </HeaderSection>

            <AreaListWrapper>
              <AreaCard filteredAreas={archivedAreas} />
            </AreaListWrapper>
          </ContentWrapper>
        )}
      </SideContainer>
    </MainContainer>
  );
};

export default ArchivedAreas;
